import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useIsMobile } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';
import * as UserAction from '@ori-events/user-action';
import React, { useCallback, useState } from 'react';
import { Arrow } from "./Arrow";
import { CATEGORY_BAR_TEST_ID, CATEGORY_BAR_TEST_ID_ITEM, CATEGORY_BAR_TEST_ID_MOBILE, CATEGORY_CLICK_EVENT_HIERARCHY } from "./constants";
import { Root, MobileRoot, MobileItem, DesktopItem, tabIndicatorStyle } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Component for displaying list of categories under hero banner. Used on front-page, plp, brands ...
 * Different components are used for mobile and desktop. Mobile using Select, desktop using Tabs.
 **/
export var CategoryBar = function CategoryBar(_ref) {
  var activeLink = _ref.activeLink,
    className = _ref.className,
    fontColor = _ref.fontColor,
    linkData = _ref.linkData,
    onClick = _ref.onClick;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var isMobile = useIsMobile();
  var _useState = useState(activeLink.id),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleTabClick = useCallback(function (link, index) {
    return function () {
      var indexPlusOne = index + 1;
      var withSegmentData = [].concat(_toConsumableArray(CATEGORY_CLICK_EVENT_HIERARCHY), [link.relativeUrl, link.title, indexPlusOne.toString()]);
      UserAction.dispatch(withSegmentData);
      if (onClick) {
        onClick(link);
      } else {
        window.location.pathname = link.relativeUrl;
      }
    };
  }, [onClick]);
  var onChange = useCallback(function (_, id) {
    return setValue(id);
  }, []);
  var onMobileChange = useCallback(function (e) {
    return setValue(e.target.value);
  }, []);
  if (linkData.length < 1) {
    return null;
  }
  if (isMobile) {
    return /*#__PURE__*/_jsx(MobileRoot, {
      fullWidth: true,
      disableUnderline: true,
      displayEmpty: true,
      className: className,
      variant: "standard",
      "data-testid": getTestId(CATEGORY_BAR_TEST_ID_MOBILE),
      defaultValue: activeLink.id,
      value: value,
      onChange: onMobileChange,
      children: linkData.map(function (link, index) {
        return /*#__PURE__*/_jsx(MobileItem, {
          value: link.id,
          onClick: handleTabClick(link, index),
          children: link.title
        }, link.id);
      })
    });
  }
  return /*#__PURE__*/_jsx(Root, {
    "data-testid": getTestId(CATEGORY_BAR_TEST_ID),
    variant: "scrollable",
    scrollButtons: "auto",
    ScrollButtonComponent: Arrow,
    TabIndicatorProps: tabIndicatorStyle,
    value: value,
    className: className,
    onChange: onChange,
    children: linkData.map(function (link, index) {
      return /*#__PURE__*/_jsx(DesktopItem, {
        value: link.id,
        "data-testid": getTestId(CATEGORY_BAR_TEST_ID_ITEM),
        hoverActiveColor: fontColor,
        label: link.title,
        onClick: handleTabClick(link, index)
      }, link.id);
    })
  });
};
//# sourceMappingURL=CategoryBar.js.map